import { SearchStages } from "../hooks/useSearchProgress";

export const SEARCH_PROGRESS_DISPLAY_STAGES = [
  SearchStages.GENERATING_QUERIES,
  SearchStages.SEARCHING_PAPERS,
  SearchStages.FETCHING_DETAILS,
  SearchStages.ANALYZING_RESULTS,
];

export const getVisibleSearchProgressStages = (progress = {}) => {
  const stages = progress.stages || {};
  return SEARCH_PROGRESS_DISPLAY_STAGES.filter((stageName) => {
    const stage = stages[stageName];
    if (!stage) return false;
    return !(
      stageName === SearchStages.GENERATING_QUERIES &&
      !stage.startTime &&
      !stage.data &&
      progress.currentStage !== SearchStages.GENERATING_QUERIES
    );
  });
};

export const getActiveSearchProgressStage = (progress = {}) => {
  if (!progress.isSearching) {
    return null;
  }

  const stages = progress.stages || {};
  const stageOrder = getVisibleSearchProgressStages(progress);
  const inProgressStage = stageOrder.find(
    (stageName) => stages[stageName]?.status === "in_progress",
  );
  if (inProgressStage) {
    return inProgressStage;
  }

  const lastCompletedIndex = stageOrder.reduce((idx, stageName, currentIndex) => {
    if (stages[stageName]?.status === "completed") {
      return currentIndex;
    }
    return idx;
  }, -1);

  const nextStage = stageOrder[lastCompletedIndex + 1];
  if (nextStage && stages[nextStage]?.status !== "completed") {
    return nextStage;
  }

  return (
    stageOrder.find((stageName) => stages[stageName]?.status !== "completed") ||
    null
  );
};

export const getSearchProgressStageLabelKey = (progress = {}) => {
  const activeStage = getActiveSearchProgressStage(progress);
  const stageName = activeStage || progress.currentStage;
  return stageName ? `stages.${stageName}` : null;
};
